import {
    Button,
    Flex,
    Menu,
    MenuButton,
    MenuDivider,
    MenuGroup,
    MenuItem,
    MenuList,
    Spinner,
    Tooltip,
} from '@chakra-ui/react';

import { ChevronDownIcon, ExportIcon } from '@assets/icons/index';
import { ConditionalComponent } from '@components/functionComponent';
import { TextBold } from '@components/typography';
import useGetAuditTrailExport from '@domain/auditTrail/usGetAuditTrailExport';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import { useFilter } from '@pages/AuditTrailSellOut/state/filters';

import styles from './styles.module.css';

const Export = () => {
    const { selectedExportAuditTrail } = useMainState();
    const filter = useFilter();
    const exportSelected = useGetAuditTrailExport({ payload: selectedExportAuditTrail, bulk: false });
    const exportAll = useGetAuditTrailExport({ payload: filter, bulk: true });

    const isExport = selectedExportAuditTrail?.length > 0;
    const isLoading = exportSelected.isPending || exportAll.isPending;

    return (
        <Menu matchWidth>
            {({ isOpen }) => (
                <>
                    <MenuButton
                        as={Button}
                        disabled={isLoading}
                        isDisabled={isLoading}
                        variant="outline"
                        borderColor="var(--color-border-grey1)"
                        borderRadius="4px"
                        rightIcon={
                            <div className={`${styles.rightIcon} ${isOpen ? styles.open : ''}`}>
                                <ChevronDownIcon />
                            </div>
                        }
                    >
                        <Flex gap="8px" alignItems="center">
                            <div className={styles.icon_container}>
                                <ConditionalComponent statement={!isLoading} fallback={<Spinner speed="1s" />}>
                                    <ExportIcon />
                                </ConditionalComponent>
                                <div className={`${styles.icon_badge} ${isExport ? styles.selected : ''}`} />
                            </div>
                            <TextBold>Export Data</TextBold>
                        </Flex>
                    </MenuButton>
                    <MenuList minWidth="unset" padding="0" overflow="clip" borderColor={'neutral.200'} zIndex={10}>
                        <MenuGroup>
                            <MenuItem padding="12px" onClick={() => exportAll.mutate()}>
                                Export All
                            </MenuItem>
                            <MenuDivider margin="0" borderColor="neutral.200" opacity={1} />
                            <Tooltip
                                label="Pilih minimal 1 row untuk export data"
                                isDisabled={isExport}
                                openDelay={150}
                            >
                                <MenuItem
                                    padding="12px"
                                    isDisabled={!isExport}
                                    onClick={() => {
                                        exportSelected.mutate();
                                    }}
                                >
                                    Export Selected
                                </MenuItem>
                            </Tooltip>
                        </MenuGroup>
                    </MenuList>
                </>
            )}
        </Menu>
    );
};

export default Export;
